export const NOOP = () => {};
export const NOOP_ASYNC = async () => {};
